import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState, useCallback } from "react";
const STORAGE_KEY = "rh-selected-lieu";
const DEFAULT_LIEU = "Siège";
const LieuContext = createContext({
    selectedLieu: DEFAULT_LIEU,
    setSelectedLieu: () => { },
});
export const LieuProvider = ({ children }) => {
    const [selectedLieu, setSelectedLieuState] = useState(() => localStorage.getItem(STORAGE_KEY) || DEFAULT_LIEU);
    const setSelectedLieu = useCallback((lieu) => {
        setSelectedLieuState(lieu);
        localStorage.setItem(STORAGE_KEY, lieu);
    }, []);
    return (_jsx(LieuContext.Provider, { value: { selectedLieu, setSelectedLieu }, children: children }));
};
export const useLieu = () => useContext(LieuContext);
